module.exports = __webpack_public_path__ + "img/icon_2_10.75906572.png";